import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange, selectedContentTypes = "" }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { symantecSESThrottleEnabled, streamConnectionTimeout } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(
      ThrottlingCheckbox,
      {
        id: "symantecSESThrottleEnabled",
        defaultChecked: symantecSESThrottleEnabled == null ? void 0 : symantecSESThrottleEnabled.value,
        onChange
      }
    ),
    (selectedContentTypes === "events" || selectedContentTypes === "events,incidents" || selectedContentTypes === "incidents,events") && /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "streamConnectionTimeout",
        name: "streamConnectionTimeout",
        type: "number",
        value: streamConnectionTimeout.value || streamConnectionTimeout.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("symantecses.advanced_options.event_stream_timeout_help"),
        label: t("symantecses.advanced_options.event_stream_timeout")
      }
    )
  );
};
export default FormAdvancedOptions;
